export const SET_TRANSACTIONS_LOADING = 'SET_TRANSACTIONS_LOADING';
export const SET_TRANSACTIONS = 'SET_TRANSACTIONS';
export const ADD_TRANSACTIONS = 'ADD_TRANSACTIONS';
export const SET_TOTAL_TRANSACTIONS_COUNT = 'SET_TOTAL_TRANSACTIONS_COUNT';
export const ADD_TOTAL_TRANSACTIONS_COUNT = 'ADD_TOTAL_TRANSACTIONS_COUNT';
export const SET_TRANSACTIONS_PAGINATION_LOADING = 'SET_TRANSACTIONS_PAGINATION_LOADING';
